module.exports = __webpack_public_path__ + "static/media/dw_logo.3d5f17a7.svg";